var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.5 169C131.168 169 169 131.168 169 84.5C169 37.8319 131.168 0 84.5 0C37.8319 0 0 37.8319 0 84.5C0 131.168 37.8319 169 84.5 169Z",
    fill: "#D4D6ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.5 158C125.093 158 158 125.093 158 84.5C158 43.9071 125.093 11 84.5 11C43.9071 11 11 43.9071 11 84.5C11 125.093 43.9071 158 84.5 158Z",
    fill: "#D4D6ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7027 148.405C120.437 148.405 149.405 119.437 149.405 83.7027C149.405 47.9684 120.437 19 84.7027 19C48.9684 19 20 47.9684 20 83.7027C20 119.437 48.9684 148.405 84.7027 148.405Z",
    fill: "#D4D6ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7033 148.405C120.438 148.405 149.406 119.437 149.406 83.7027C149.406 47.9684 120.438 19 84.7033 19C48.969 19 20.0006 47.9684 20.0006 83.7027C20.0006 119.437 48.969 148.405 84.7033 148.405Z",
    fill: "#D4D6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0017 30.7876C73.0017 30.7876 52.9542 36.8105 54.8471 68.5595V137.048H77.6479L73.0017 30.7876Z",
    fill: "url(#paint0_linear_16_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6789 51.3514V149.696H114.302V66.8388C114.302 66.8388 117.141 35.0897 96.319 31.1319C96.319 31.1319 70.6789 26.4857 70.6789 51.3514Z",
    fill: "url(#paint1_linear_16_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9321 114.333H69.5597V129.39H99.9321V114.333Z",
    fill: "#A5DEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.403 154.084H112.839L109.139 139.285C109.139 139.285 106.128 116.828 121.615 116.484C121.615 116.484 129.617 122.077 131.768 135.327C131.854 135.327 133.575 145.824 133.403 154.084Z",
    fill: "#DCDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1606 154.084L64.9139 142.899C64.9139 142.899 69.8183 117.947 54.417 117.603C54.417 117.603 43.2317 126.809 44.0921 154.084H62.1606Z",
    fill: "#DCDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4048 83.9606H77.6479V111.408H96.4048V83.9606Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3187 95.146V83.9606H77.6479V100.05C83.8428 99.8782 91.1563 98.7597 96.3187 95.146Z",
    fill: "#CBCBB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7817 120.098C56.9977 113.559 63.6229 111.838 63.6229 111.838L79.4544 105.987H94.5975L113.957 111.838C113.957 111.838 120.582 113.559 124.798 120.098H52.7817Z",
    fill: "#A5DEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6547 142.383V154.084H117.4L116.711 140.49C115.937 114.247 118.862 114.247 118.862 114.247C116.109 112.44 113.872 111.838 113.872 111.838L98.6426 107.536C98.6426 107.536 95.3731 121.733 82.7251 121.733C82.7251 121.733 73.0025 116.484 75.6697 107.364L63.624 111.838C63.624 111.838 58.8057 113.301 54.4176 117.603C54.3316 117.689 56.4826 118.979 56.6547 142.383Z",
    fill: "#B2B7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3845 86.1119C97.7822 87.5746 96.8357 88.9512 95.6312 90.1558C92.5337 93.1672 88.834 95.5763 84.8761 97.2972C79.9717 99.2761 72.5722 99.5342 68.7004 95.4903C65.5169 92.2208 63.7961 87.2304 62.4194 83.0144C59.7522 74.7545 59.7522 65.7202 60.4405 57.2022C60.6126 55.2232 60.7846 53.3303 61.1288 51.3514C64.2263 32.5945 80.2299 32.6805 80.2299 32.6805C92.2756 32.1643 103.375 37.843 105.182 50.577C105.87 55.4813 104.924 60.7298 104.751 65.5481C104.579 69.1618 104.149 72.6895 102.945 76.1311C101.74 79.6588 99.8472 82.7563 98.3845 86.1119Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9327 71.915C99.9327 71.915 101.568 65.2899 106.644 68.0432C106.644 68.0432 108.967 69.2478 107.332 73.8079C107.332 73.8079 104.923 80.347 99.9327 77.9379V71.915Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2351 53.5023C58.3747 27.7761 82.8103 28.9807 82.8103 28.9807C106.73 29.9271 107.934 40.8543 107.934 40.8543C110.86 54.6208 106.644 67.9572 106.644 67.9572C101.567 66.8386 100.707 73.6358 100.707 73.6358C101.223 62.7087 100.363 62.1064 100.363 62.1064C88.489 55.9114 78.6803 50.2327 62.3326 57.8043C62.3326 57.8043 59.3212 57.9764 59.3212 67.2688V53.5023H59.2351Z",
    fill: "url(#paint2_linear_16_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4518 87.0584C63.4518 87.0584 66.5493 102.116 76.7021 106.762C58.8056 118.721 54.6757 121.905 54.6757 121.905L54.9338 98.846L63.4518 87.0584Z",
    fill: "url(#paint3_linear_16_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.084 78.5404C102.084 78.5404 103.03 100.137 64.57 111.064C46.7596 117.947 46.1573 128.874 46.1573 128.874C46.1573 128.874 87.1988 157.01 132.198 137.65C130.133 119.926 126.003 115.71 113.957 111.924",
    fill: "url(#paint4_linear_16_130)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_130",
    x1: 61.8533,
    y1: 42.311,
    x2: 65.3249,
    y2: 113.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#603076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3661,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6839,
    stopColor: "#C92459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_130",
    x1: 108.489,
    y1: 64.1166,
    x2: 61.5635,
    y2: 161.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_130",
    x1: 105.467,
    y1: 61.0099,
    x2: 66.9423,
    y2: 44.4758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_130",
    x1: 62.0985,
    y1: 42.2991,
    x2: 65.5701,
    y2: 113.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#603076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3661,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6839,
    stopColor: "#C92459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_130",
    x1: 135.4,
    y1: 94.5286,
    x2: 73.4586,
    y2: 140.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 129.405,
    height: 135.084,
    rx: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedFemale);
export default __webpack_public_path__ + "static/media/selected-female.470c5d223cd74b596e8ef8224658c76d.svg";
export { ForwardRef as ReactComponent };